import React, { Component } from 'react'
import Nouveaute from './components/Nouveaute'
import Nouveaute2 from './components/Nouveaute2'
import Pagination from './components/Pagination'
import Clienteles from './components/Clienteles'
import Systemes from './components/Systemes'

class App extends Component {
  constructor(props) {
    super(props);
		this.handleChange = this.handleChange.bind(this);
  }

	state = {
		titre: 'Nouveautés et améliorations',
		error: null,
		isLoaded: false,
		nombrePages: 1,
		pageCourante: 1,
		nouveautesParPage: 10,
		systemes: [],
		clienteles: [],
		nouveautes: [],
		adresseJson: process.env.REACT_APP_ADRESSE + '/wp-json/wp/v2/'
	}

  componentDidMount() {
		const parametres = new URLSearchParams( window.location.search );
		let pageCourante = parametres.get( 'page' )
		if ( pageCourante == null ){
			pageCourante = 1;
		}
		this.setState( {
			pageCourante: parseInt( pageCourante )
		} );
		fetch( this.state.adresseJson + 'systeme' )
		.then( reponse => reponse.json() )
		.then(
			( leJson ) => {
				this.setState( {
					systemes: leJson,
				} );
				return fetch( this.state.adresseJson + 'clientele' );
			}
		)
		.then( reponse => reponse.json() )
		.then(
			( leJson ) => {
				this.setState( {
					clienteles: leJson,
				} );
				return fetch( this.state.adresseJson + 'nouveaute?per_page=' + this.state.nouveautesParPage + '&page=' + pageCourante, { cache: 'no-store' } )
			}
		)
		.then( ( reponse ) => {
			this.setState( {
				nombrePages: parseInt( reponse.headers.get( 'X-WP-TotalPages' ) ),
			} );
			return reponse.json();
		})
		.then(
			( leJson ) => {
				this.setState( {
					isLoaded: true,
					nouveautes: leJson
				} );
			}
		)
	}

	componentDidUpdate() {
		window.onpopstate = (e) => {
			if ( ! window.location.hash ) { // Si le "onpopstate" ne vient pas de l'utilisation du lien "Aller au contenu principale" (#contenu)
				this.handleChange( "retour" );
			}
		}
	}

	handleChange( change, numeroPage ) {
		var page = 1;
		if ( 'page' === change ) {
			page = numeroPage;
		} else if ( 'retour' === change ) { // Gestion du bouton "retour" du navigateur
			const parametres = new URLSearchParams( window.location.search );
			const pageUrl = parametres.get( 'page' );
			if ( pageUrl ) {
				page = parseInt( pageUrl );
			}
		}
		this.setState( {
			pageCourante: page
		} );
		var systemes = '';
		Array.from( document.getElementsByName( 'systeme' ) ).forEach( ( systeme ) => {
			if( systeme.getAttribute( 'aria-checked' ) === 'true' ) {
				systemes = systemes + systeme.value + ",";
			}
		} );
		var clienteles = '';
		Array.from( document.getElementsByName( 'clientele' ) ).forEach( ( clientele ) => {
			if( clientele.getAttribute( 'aria-checked' ) === 'true' ) {
				clienteles = clienteles + clientele.value + ",";
			}
		} );
		if (systemes && clienteles) {
			fetch( this.state.adresseJson + 'nouveaute?per_page=' + this.state.nouveautesParPage + '&systeme=' + systemes + '&page=' + page + '&clientele=' + clienteles )
			.then( ( reponse ) => {
				this.setState( {
					nombrePages: parseInt( reponse.headers.get( 'X-WP-TotalPages' ) ),
				} );
				return reponse.json();
			})
			.then(
				( leJson ) => {
					this.setState( { nouveautes: leJson } );
				}
			)
		} else {
			this.setState( { nombrePages: 0 } );
		}
	}

	// Ouverture et fermeture du "panneau" des filtres. Il y aurait peut-être eu une façon plus "React" de procéder, mais le code était déjà écrit pour les filtres de la recherche.
	gestionMenu( ) {
		const declencheurMenuPage = document.getElementsByClassName( 'declencheur-menu-page' )[ 0 ];
		const panneauMenuPage = document.getElementsByClassName( 'panneau-menu-page' )[ 0 ];
		if ( declencheurMenuPage.getAttribute( 'aria-expanded' ) ) {
			declencheurMenuPage.removeAttribute( 'aria-expanded' );
			panneauMenuPage.classList.remove( 'ouvert' );
		} else {
			declencheurMenuPage.setAttribute( 'aria-expanded', 'true' );
			panneauMenuPage.classList.add( 'ouvert' );
		}
	}

  render() {
    const { error, isLoaded, titre, systemes, adresseJson, clienteles, nouveautes, nombrePages, pageCourante } = this.state;
    if ( error ) {
      return <p className='nouveautes-erreur'>{ error.message }</p>;
    } else if (!isLoaded) {
			// Indicateur de progression de ModUL: https://ulaval.github.io/modul/composants/interface/butons-et-indicateurs/indicateur-de-progression/portrait.
      return (
				<div className="chargement">
					<div className="m-progress">
						<div className="m-progress__wrap">
							<svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 50 50" className="m-progress__draw">
								<circle cx="50%" cy="50%" r="23" className="m-progress__circle"></circle>
							</svg>
						</div>
					</div>
				</div>
			);
    } else {
      return (
				<>
					<style
						dangerouslySetInnerHTML={{__html: `
							html {
									scroll-behavior: auto; // Le défilement "smooth" mis en place ailleurs crée des problèmes dans l'application des nouveautés.
								}
						`}}
					/>
					<div className="tiers-wrap">
						<div className="tiers">
							<section className="menu-nouveautes" aria-label="Menu des filtres.">
								<button aria-haspopup="menu" aria-controls="filtres" className="declencheur-filtres-nouveautes declencheur-menu-page" onClick={ this.gestionMenu }>Filtrer les nouveautés <img className="icone-filtres" src="/wp-content/themes/aide-brio/img/icones/filtres.svg" alt="" /></button>
								<div className="filtres panneau-menu-page" id='filtres'>
									<h2>Filtrer les nouveautés</h2>
									<div className="filtres-regroupement">
										<Clienteles
											key='clienteles'
											clienteles={ clienteles }
											onChange={ this.handleChange }
										/>
									</div>
									<div className="filtres-regroupement">
										<Systemes
											key='systemes'
											systemes={ systemes }
											adresseJson={ adresseJson }
											onChange={ this.handleChange }
										/>
									</div>
								</div>
							</section>
						</div>
					</div>
					<main id="nouveautes-contenu" aria-live="polite" className="nouveautes-contenu deux-tiers">
						<nav className="fil-ariane" aria-label="Fil d'Ariane."><span><span><a href="/">Accueil</a></span></span></nav>
						<h1 id="contenu">{ titre }</h1>
						{nombrePages ? (
							<>
							{ nouveautes.map( nouveaute => ( // À partir du 2024-05-22, on affiche le nouveau template des nouvelles
								new Date(nouveaute.date) >= new Date('2024-05-22') ? (
									<Nouveaute2
										key={ nouveaute.id }
										date={ nouveaute.date }
										title={ nouveaute.title[ "rendered" ] }
										link={ nouveaute.link }
										excerpt={ nouveaute.excerpt[ "rendered" ] }
										systemesActuels={ nouveaute.systeme }
										clientelesActuelles={ nouveaute.clientele }
										systemesTous={ systemes }
										clientelesToutes={ clienteles }
										locale={ document.documentElement.lang || 'fr' }
									/>
								) : (
									<Nouveaute
										key={ nouveaute.id }
										date={ nouveaute.date }
										content={ nouveaute.content[ "rendered" ] }
										systemesActuels={ nouveaute.systeme }
										clientelesActuelles={ nouveaute.clientele }
										systemesTous={ systemes }
										clientelesToutes={ clienteles }
										locale={ document.documentElement.lang || 'fr' }
									/>
								)
							) ) }
								<Pagination
									key='pagination'
									nombrePages={ nombrePages }
									pageCourante={ pageCourante }
									onChange={ this.handleChange }
								/>
							</>
						) : (
							<p>Aucune nouveauté ne correspond à vos critères.</p>
						)}
					</main>
				</>
      );
    }
	}
}
export default App
